import { createSlice } from '@reduxjs/toolkit';

import {
  fetchContractById,
  fetchContractingParty,
} from '../../Services/documentViewAPI';

interface DocumentViewState {
  activeTab: number;
  contractData: {
    loading: boolean;
    data: any | null;
    errors: any | null;
  };
  contractingParties: any;
}

// Define the initial state using that type
const initialState: DocumentViewState = {
  activeTab: 0,
  contractData: {
    loading: false,
    data: null,
    errors: null,
  },
  contractingParties: null,
};

export const documentViewSlice = createSlice({
  name: 'documentView',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setActiveTab: (state, actions) => {
      state.activeTab = actions.payload;
    },
    getContractDataAction: (state) => {
      state.contractData.loading = true;
    },
    getContractDataSuccessAction: (state, action) => {
      state.contractData.loading = false;
      state.contractData.data = action.payload;
    },
    getContractDataFailureAction: (state, action) => {
      state.contractData.loading = false;
      state.contractData.errors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchContractById.fulfilled, (state, { payload }) => {
      state.contractData.data = payload;
    });
    builder.addCase(fetchContractingParty.fulfilled, (state, { payload }) => {
      state.contractingParties = payload;
    });
  },
});

export const {
  setActiveTab,
  getContractDataAction,
  getContractDataFailureAction,
  getContractDataSuccessAction,
} = documentViewSlice.actions;

// Other code such as selectors can use the imported `RootState` type

export default documentViewSlice.reducer;
